var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.08754 4.8376C3.31535 4.6098 3.68469 4.6098 3.9125 4.8376L7.00002 7.92512L10.0875 4.8376C10.3153 4.6098 10.6847 4.6098 10.9125 4.8376C11.1403 5.06541 11.1403 5.43475 10.9125 5.66256L7.4125 9.16256C7.18469 9.39037 6.81535 9.39037 6.58754 9.16256L3.08754 5.66256C2.85974 5.43475 2.85974 5.06541 3.08754 4.8376Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjA4NzU0IDQuODM3NkMzLjMxNTM1IDQuNjA5OCAzLjY4NDY5IDQuNjA5OCAzLjkxMjUgNC44Mzc2TDcuMDAwMDIgNy45MjUxMkwxMC4wODc1IDQuODM3NkMxMC4zMTUzIDQuNjA5OCAxMC42ODQ3IDQuNjA5OCAxMC45MTI1IDQuODM3NkMxMS4xNDAzIDUuMDY1NDEgMTEuMTQwMyA1LjQzNDc1IDEwLjkxMjUgNS42NjI1Nkw3LjQxMjUgOS4xNjI1NkM3LjE4NDY5IDkuMzkwMzcgNi44MTUzNSA5LjM5MDM3IDYuNTg3NTQgOS4xNjI1NkwzLjA4NzU0IDUuNjYyNTZDMi44NTk3NCA1LjQzNDc1IDIuODU5NzQgNS4wNjU0MSAzLjA4NzU0IDQuODM3NloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";